import { MoviePlayOutlineIcon } from './MoviePlayOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 48071069-C2BD-4B35-97A1-0167DB7B1B13
 * name movie-play-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-play-outline.svg
 * tags
 * - Video / Movie 
 */
export const FilmPlayOutlineIcon = MoviePlayOutlineIcon;
export default FilmPlayOutlineIcon